export class ValidationErrorModel {
  field: string | null = null;
  errorType: string | null = null;
  error: string | null = null;
  //params: any;
}
